export enum ToastType {
    Error,
    Success,
    Warning,
    Info
}
